<template>
  <div class="w-full grid grid-cols-3 gap-8">
    <!--<button class="bg-[#fafafa] !text-black text-opacity-90 rounded-lg shadow-lg cursor-default">
      <div class="p-4 flex space-x-1 justify-center w-full flex-1 items-start">
        <v-tooltip location="top">
          <template v-slot:activator="{ props }">
            <Icon
              v-bind="props"
              icon="ant-design:file-word-outlined"
              class="text-xl cursor-pointer"
            />
          </template>
          <div class="w-40 whitespace-normal text-center">
            With the WriteWise membership you have access to our Microsoft Word Add-In
          </div>
        </v-tooltip>
        <span class="text-center">Add-In</span>
      </div>

      <hr class="border-grey" />

      <div class="p-5 flex flex-col items-center">
        <span class="text-center text-xs text-grey text-opacity-10"
          >With the WriteWise membership you have access to our Microsoft Word Add-In</span
        >
      </div>

      <hr class="border-grey" />

      <div class="p-3 flex items-center justify-center w-full">
        <v-btn
          variant="flat"
          class="!py-3 !bg-primary-main !rounded-xl !tracking-normal !capitalize !text-white !h-auto"
        >
          <template v-slot:prepend>
            <Icon icon="ant-design:link" class="text-xl" />
          </template>
          Coming Soon
        </v-btn>
      </div>
    </button> -->
    <button class="bg-[#fafafa] !text-black text-opacity-90 rounded-lg shadow-lg cursor-default">
      <div class="p-4 flex space-x-1 justify-center w-full flex-1 items-start">
        <v-tooltip location="top">
          <template v-slot:activator="{ props }">
            <Icon
              v-bind="props"
              icon="ant-design:folder-open-outline"
              class="text-xl cursor-pointer"
            />
          </template>
          <div class="w-40 whitespace-normal text-center">
            If you find it difficult to write academic articles in English, this is the course for
            you (currently only available with Spanish audio).
          </div>
        </v-tooltip>
        <span class="text-center">Academic Writing Course</span>
      </div>

      <hr class="border-grey" />

      <div class="p-5 flex flex-col items-center">
        <span class="text-center text-xs text-grey text-opacity-10"
          >If you find it difficult to write academic articles in English, this is the course for
          you (currently only available with Spanish audio).</span
        >
      </div>

      <hr class="border-grey" />

      <div class="p-3 flex items-center justify-center w-full">
        <v-btn
          @click="openCourse()"
          variant="flat"
          class="!py-3 !bg-primary-main !rounded-xl !tracking-normal !capitalize !text-white !h-auto"
        >
          <template v-slot:prepend>
            <Icon icon="ant-design:link" class="text-xl" />
          </template>
          Get Now
        </v-btn>
      </div>
    </button>
    <button class="bg-[#fafafa] !text-black text-opacity-90 rounded-lg shadow-lg cursor-default">
      <div class="p-4 flex space-x-1 justify-center w-full flex-1 items-start">
        <v-tooltip location="top">
          <template v-slot:activator="{ props }">
            <Icon v-bind="props" icon="ant-design:info-circle" class="text-xl cursor-pointer" />
          </template>
          <div class="w-40 whitespace-normal text-center">
            Improve your Spanish academic writing skills with our specialized software designed
          specifically for Spanish-speaking users.
          </div>
        </v-tooltip>
        <span class="text-center">WriteWise Spanish</span>
      </div>

      <hr class="border-grey" />

      <div class="p-5 flex flex-col items-center">
        <span class="text-center text-xs text-grey text-opacity-10"
          >Improve your Spanish academic writing skills with our specialized software designed
          specifically for Spanish-speaking users.</span
        >
      </div>

      <hr class="border-grey" />

      <div class="p-3 flex items-center justify-center w-full">
        <v-btn
          @click="openSpanish()"
          variant="flat"
          class="!py-3 !bg-primary-main !rounded-xl !tracking-normal !capitalize !text-white !h-auto"
        >
          <template v-slot:prepend>
            <Icon icon="ant-design:link" class="text-xl" />
          </template>
          Get Now
        </v-btn>
      </div>
    </button>
  </div>
</template>

<script lang="ts">
import { Vue, Options } from 'vue-class-component';
import { Icon } from '@iconify/vue';
import contenteditable from 'vue-contenteditable';
import { Watch } from 'vue-property-decorator';

@Options({
  components: {
    Icon,
    contenteditable
  }
})
export default class Products extends Vue {
  public openAddin() {
    (
      window.open(
        'https://appsource.microsoft.com/en-us/product/office/wa200002980?tab=overview&exp=ubp8',
        '_blank'
      ) as any
    ).focus();
  }

  public openCourse() {
    (
      window.open(
        'https://web.writewise.io/courses/',
        '_blank'
      ) as any
    ).focus();
  }

  public openSpanish() {
    (window.open(process.env.WEB_BASE_URL+'/writewise-plans/', '_blank') as any).focus();
  }
}
</script>
